import { checkoutService } from '@afterpaytouch/portal-api/consumer/checkout'

export const {
  useGetPayableOrderTransactionsQuery,
  useLazyGetCheckoutPpaDocumentQuery,
  useLazyGetCheckoutPpaDocumentPDFQuery,
  endpoints: { getPayableOrderTransactions, getCheckoutPpaDocument },
} = checkoutService
